var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutBlob2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 240,
    height: 251.231,
    viewBox: "0 0 240 251.231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Watercolor blob",
    opacity: 0.7,
    filter: "url(#filter0_f_0_24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M124.138 24.0674C161.379 13.4007 194.483 45.4007 206.897 88.0674C219.31 130.734 215.172 178.734 186.207 205.401C157.241 232.067 107.586 237.401 74.4828 216.067C41.3793 194.734 24.8276 152.067 33.1034 109.401C41.3793 66.734 86.8966 34.734 124.138 24.0674Z",
    fill: "url(#paint0_linear_0_24)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_0_24",
    x: -22,
    y: -19.266,
    width: 284,
    height: 284,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    result: "effect1_foregroundBlur_0_24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_24",
    x1: 30.9945,
    y1: 22,
    x2: 177.829,
    y2: 151.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FB3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2D2FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutBlob2);
export default __webpack_public_path__ + "static/media/about-blob-2.64193bdafefd7eceb9e92bdf4f50e57d.svg";
export { ForwardRef as ReactComponent };